export const server_name = "cooksy-app-server";
export const server_name_ws = "JcIa205uXQnHzIVpWe78FqiNkOQ9riFCnME";
export const server_name_wt = "cooksy.teonet.dev:8087";